// EVA-275: decides whether the report needs another request, and whether that
// request is allowed to blank the grid.
//
// Pure: no React, no fetch — unit-testable under bare node like the rest of
// `report/`. It exists because the two questions used to be one: `detailed` is
// derived from the expanded row set, so expanding the first row changed the load
// effect's identity and re-ran it in its spinner-showing form, tearing the whole
// table down for a response that only ADDS children under rows already on screen.
//
// `held` is what the payload currently in state represents — { view, detailed },
// taken from the response's own echo — or null before the first response lands.
export function fetchPlan({ held, view, detailed }) {
  // Nothing on screen yet, or a different frequency: the table is genuinely
  // being replaced (tenant rows included, since they are bucketed to the old
  // frequency and cannot be reused), so the spinner is honest.
  if (!held || held.view !== view) return { spinner: true }

  // Same frequency, detail requested and not held: fetch, but leave the grid
  // standing. Every number on screen stays valid; the response only splices in
  // the tenant children.
  if (detailed && !held.detailed) return { spinner: false }

  // Everything else needs no request. In particular collapsing the last row
  // (detailed true → false) does NOT refetch: what we hold is a superset of the
  // small payload, and the next realtime refetch drops back to it on its own.
  return null
}
